<template>
  <item-nav :id="$attrs['id']">
  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty } from 'lodash';
import ItemNavGroup from './ItemNavGroup';
import ItemNavGroupItem from './ItemNavGroupItem';
import HotelmeisterMixin from '../../../../mixins/HotelmeisterMixin';

export default {
  name: 'EmptyNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
    };
  },

  computed: {
  },

  created: function () {
  },

  mounted: function () {
    this.$emit('widenav', false);
  },

  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/EmptyNav.vue